import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class DefOrgConfigMatrixService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/DefOrgConfigMatrices`);
    }

    public GetBySectorEditionCountry(
        sectorID?: number,
        editionID?: number,
        systemCountryID?: number
    ): Promise<IEntity[]> {

        const query = `GetBySectorEditionCountry?sectorID=${sectorID ?? ''}&editionID=${editionID ?? ''}&systemCountryID=${systemCountryID ?? ''}`;
        return this.readAll(query);
    }
}